import React from 'react';
import Header from '../components/Header';
import Contact from './Contact';
import { Link } from 'react-router-dom';
import StripePricingTable from '../components/StripePricingSponsors';

const Partnerships = ()  => {
  const videoId = 'B-bufubLFH0';
  document.title = 'Unieros - Partner with us';
    return (
      <div className="partnerships">
      <div className="container">
        <h1 className="display-1 page-title">Partner with Unieros</h1>
        <p className="lead">
          Unieros events are an excellent opportunity for businesses to showcase their brands and connect with a diverse and engaged audience. 
        </p>
        <div className="embed-responsive embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="Latest Video from Unieros community"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div>
      <h3 className="display-6">Become an event Sponsor</h3>
        <p>
          Our partnership program offers a variety of options to help you reach your target audience and maximize brand exposure.</p>
          
          <p>
           From event sponsorships to co-branded marketing campaigns, we work closely with our partners to create a tailored plan that meets their unique needs and objectives.
        </p>
        </div>
        <div className="hero-sponsor">
        <h4 className="">Why Partner with Unieros</h4>
    
        <div className="signature-events">
        <img src="https://unieros.com/wp/wp-content/uploads/2016/06/brasilFest.jpg" class="rounded"  alt="Unieros Brazil festival tour" width="300"/>
        <img src="https://unieros.com/wp/wp-content/uploads/2016/06/SonTrio.jpg" class="rounded" alt="Unieros Roots Rock Reggae concert in Chicago" width="300"/>
<img src="https://unieros.com/wp/wp-content/uploads/2023/06/unieros_french_picnic-1024x1024.jpeg" class="rounded " alt="Unieros event America the Beautiful fashion show" width="300"/>
        </div>
       
        <p>With over a decade of experience in hosting multicultural events, Unieros has proudly organized and curated unforgettable experiences in vibrant cities such as Chicago, New York, and Savannah, Georgia.</p>
       </div>
       {/* <div>
       <figure class="text-center">
  <blockquote class="blockquote red-quote">
    <p className="display-6">We are more alike than unalike.</p>
  </blockquote>
  <figcaption class="blockquote-footer">
    <cite title="Source Title">Maya Angelou</cite>
  </figcaption>
</figure>
       </div> */}
        <div className="text-center">
          <h4 className="display-6">Event sponsor options</h4>
          <StripePricingTable />
       </div>
       <div className="text-center hero-sponsor">
        
        <img src="https://unieros.com/wp/wp-content/uploads/2016/05/20161019_193524-1024x576.jpg" alt="Unieros Connecting Startups Across Cultures in Chicago" className="img-fluid" />
        <h3 className="display-6">Attention Corporate Sponsors</h3>
        <p> We invite you to explore a special partnership opportunity with Unieros. As a corporate sponsor, you have the chance to align your brand with our dynamic and culturally enriching events. By joining forces, we can create a mutually beneficial collaboration that promotes diversity, community engagement, and positive brand exposure.</p>
        <Link to="/contact" className="btn btn-custom-primary">Contact us</Link>
        </div>
      </div>
      </div>
    );
  }

  export default Partnerships;